<div class="AmInputForm">
  <div class="AmInputForm-input" [ngClass]="{ 'AmInputForm-input--fullSize': inputFullSize }">
    <input
          [id]="formControlName"
          [formControl]="textControl"
          [placeholder]="placeholder | translate"
          autocomplete="off"
          class="form-control"
          readonly
          [ngClass]="{
              'input--error': (textControl.touched && textControl.invalid),
               'am-input-rb': className == 'am-input-rb'
          }"
          type="text"
          (click)="openModalList()"
          [readOnly]="readOnly"
          data-type="selectAm"
      >
  </div>
  <app-form-error-message style="width: 24%;"
      [fieldInput]="textControl"
      [errorRequired]="errorRequired"
      [errorPattern]="errorPattern"
  ></app-form-error-message>
</div>
